//#region frontend/entrypoints/sf-cart.js
(function() {
	var checkoutBtn = document.getElementById("checkout");
	if (!checkoutBtn) return;
	var hasP13n = checkoutBtn.dataset.p13nConfirm === "true";
	var hasCodNg = checkoutBtn.dataset.codNgConfirm === "true";
	if (!hasP13n && !hasCodNg) return;
	var queue = [];
	var currentStep = 0;
	var nativeSubmit = HTMLFormElement.prototype.submit;
	var skipModalCheck = false;
	HTMLFormElement.prototype.submit = function() {
		if (this.id === "cart" && !skipModalCheck) {
			buildQueue();
			if (queue.length > 0) {
				currentStep = 0;
				openModal(queue[0]);
				return;
			}
		}
		nativeSubmit.call(this);
	};
	function buildQueue() {
		var flagsEl = document.getElementById("cart-checkout-flags");
		queue = [];
		if (flagsEl && flagsEl.dataset.p13n === "true" && document.getElementById("cart-p13n-modal")) queue.push("cart-p13n-modal");
		if (flagsEl && flagsEl.dataset.codNg === "true" && document.getElementById("cart-cod-ng-modal")) queue.push("cart-cod-ng-modal");
	}
	function submitCart() {
		var form = document.getElementById("cart");
		if (!form) return;
		var hidden = document.createElement("input");
		hidden.type = "hidden";
		hidden.name = "checkout";
		hidden.value = "";
		form.appendChild(hidden);
		skipModalCheck = true;
		if (form.requestSubmit) form.requestSubmit();
		else nativeSubmit.call(form);
	}
	function openModal(id) {
		var el = document.getElementById(id);
		if (!el) return;
		el.removeAttribute("hidden");
		el.classList.add("is-active");
		var proceed = el.querySelector("[data-proceed]");
		if (proceed) proceed.focus();
	}
	function closeModal(id) {
		var el = document.getElementById(id);
		if (!el) return;
		el.setAttribute("hidden", "");
		el.classList.remove("is-active");
	}
	function proceedStep() {
		closeModal(queue[currentStep]);
		currentStep++;
		if (currentStep < queue.length) openModal(queue[currentStep]);
		else submitCart();
	}
	function cancelAll() {
		closeModal(queue[currentStep]);
		currentStep = 0;
		checkoutBtn.focus();
	}
	["cart-p13n-modal", "cart-cod-ng-modal"].forEach(function(id) {
		var el = document.getElementById(id);
		if (!el) return;
		el.querySelector(".p-cart__modal-overlay").addEventListener("click", cancelAll);
		el.querySelector(".p-cart__modal-close").addEventListener("click", cancelAll);
		el.querySelector("[data-cancel]").addEventListener("click", cancelAll);
		el.querySelector("[data-proceed]").addEventListener("click", proceedStep);
	});
	checkoutBtn.addEventListener("click", function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		buildQueue();
		if (queue.length > 0) {
			currentStep = 0;
			openModal(queue[0]);
		} else submitCart();
	}, true);
	var cartForm = document.getElementById("cart");
	if (cartForm) cartForm.addEventListener("submit", function(e) {
		if (skipModalCheck) return;
		buildQueue();
		if (queue.length > 0) {
			e.preventDefault();
			currentStep = 0;
			openModal(queue[0]);
		}
	});
	document.addEventListener("keydown", function(e) {
		if (e.key === "Escape") {
			if (document.querySelector(".p-cart__modal.is-active")) cancelAll();
		}
	});
})();
//#endregion
